<template>
  <section class="selecting-test-form" v-loading="loading" id="supply-request">
    <div class="logo-navbar">
      <div class="logo-dlw" v-if="dlwRouteName.indexOf($route.name) != -1">
        <img src="@/assets/images/dlw-logo.webp" alt="logo" />
      </div>
      <div class="logo-mgh" v-if="mghRouteName.indexOf($route.name) != -1">
        <img src="@/assets/images/mgh-logo-new.png" alt="logo" />
      </div>
    </div>
    <div class="step-3" id="content-body">
      <h3 class="form-title">Supply Request Form</h3>
      <div class="step-content">
        <div class="ordering-form">
          <el-form :model="logisticInformation" ref="ruleForm" :rules="rules">
            <el-row :gutter="15">
              <el-col :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
                <el-form-item
                  prop="employee_name"
                  label="Employee Name"
                  class="mandatory-field"
                >
                  <el-input
                    v-model="logisticInformation.employee_name"
                    placeholder="Enter Employee Name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
                <el-form-item
                  prop="date_requested"
                  label="Date Requested"
                  class="mandatory-field"
                >
                  <el-date-picker
                    style="width: 200px"
                    v-model="logisticInformation.date_requested"
                    placeholder="Select Date Requested"
                    align="right"
                    format="MM-DD-YYYY"
                    value-format="YYYY-MM-DD"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="each-supply-step">
              <ul>
                <li class="heading">
                  <p></p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>Needles</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.needles['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.needles['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Butterfly Needle</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.butterfly_needle['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.butterfly_needle['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Tubes</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.tubes['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.tubes['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Lavender Top/EDTA</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.lavender_top_edta['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.lavender_top_edta['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Light Blue Tubes</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.light_blue_tubes['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.light_blue_tubes['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>SST/Tiger Top</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.sst_tiger_top['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.sst_tiger_top['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Lithium Heparin/Green Top</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.lithium_heparin_green_top[
                            'requested'
                          ]
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.lithium_heparin_green_top['taken']
                        "
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Transfer tubes</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.transfer_tubes['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.transfer_tubes['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Urinalysis Tubes</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.urinalysis_tubes['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.urinalysis_tubes['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <ul>
                <li class="heading">
                  <p>Shipping Supplies</p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>Straight Needles 21g</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.straight_needles_21g['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.straight_needles_21g['taken']
                        "
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Straight Needles 23g</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.straight_needles_23g['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.straight_needles_23g['taken']
                        "
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <ul>
                <li class="heading">
                  <p>Collection Supplies</p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>2X2 Gauze</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.two_by_two_gauze['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.two_by_two_gauze['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Alcohol Prep Pads</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.alcohol_prep_pads['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.alcohol_prep_pads['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Bandaids</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.bandaids['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.bandaids['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Coban</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.coban['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.coban['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Tourniquet</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.tourniquet['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.tourniquet['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Hubs/Needle Holders</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.hubs_needle_holders['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.hubs_needle_holders['taken']
                        "
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <ul>
                <li class="heading">
                  <p></p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>Kangaroo Mailers</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.kangaroo_mailers['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.kangaroo_mailers['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Ice Packs</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.ice_packs['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.ice_packs['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Fed Ex Bags</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.fed_ex_bags['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.fed_ex_bags['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Fed Ex Labels</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.fed_ex_labels['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.fed_ex_labels['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <ul>
                <li class="heading">
                  <p></p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>Printer Paper</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.printer_papers['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.printer_papers['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Label Rolls</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.label_rolls['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.label_rolls['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Printer Ink</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.printer_ink['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.printer_ink['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Sharps Containers</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.sharps_containers['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.sharps_containers['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Waste Pickup Boxes</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.waste_pickup_boxes['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.waste_pickup_boxes['taken']
                        "
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <ul>
                <li class="heading">
                  <p></p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>FOBT kits</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.fobt_kits['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.fobt_kits['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>H.Pylori Test Kits</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.h_pylori_test_kits['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.h_pylori_test_kits['taken']
                        "
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Tox/UTI/STD Kits</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="
                          logisticInformation.tox_uti_std_kits['requested']
                        "
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.tox_uti_std_kits['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Pap Test Kits</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.pap_test_kits['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.pap_test_kits['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <ul>
                <li class="heading">
                  <p></p>
                  <p>Qty Requested</p>
                  <p>Qty Taken</p>
                </li>
                <li>
                  <div class="name">
                    <h4>Other</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.other_1['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.other_1['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Item</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.other_2['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.other_2['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
                <li>
                  <div class="name">
                    <h4>Item</h4>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.other_3['requested']"
                        placeholder="Enter Requested QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <el-form-item class="mandatory-field">
                      <el-input
                        v-model="logisticInformation.other_3['taken']"
                        placeholder="Enter Taken QTY"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
            </div>
          </el-form>
          <div class="step-action-block">
            <ul>
              <li>
                <el-button class="btn-success" @click="orderATest"
                  >Cancel</el-button
                >
              </li>
              <li v-if="dlwRouteName.indexOf($route.name) != -1">
                <el-button class="btn-primary" @click="submitForm('ruleForm')"
                  >Submit</el-button
                >
              </li>
              <li v-if="mghRouteName.indexOf($route.name) != -1">
                <el-button class="btn-primary" @click="supplyForm('ruleForm')"
                  >Submit</el-button
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import "vue-tel-input/dist/vue-tel-input.css";
import { mapGetters } from "vuex";
import moment from "moment";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
// import { VueTelInput } from "vue-tel-input";

export default {
  name: "OrderATest",
  components: {
    // FormError,
    // VueTelInput,
  },
  data() {
    return {
      dlwRouteName: ["DLW-Supply-Request"],
      mghRouteName: ["MGH-Supply-Request"],
      FormCategories: [
        {
          category_name: "",
          fields: [
            {
              label: "Needles",
              key: "needles",
              requested: "",
              taken: "",
            },
            {
              label: "Butterfly Needle",
              key: "butterfly_needle",
              requested: "",
              taken: "",
            },
            {
              label: "Tubes",
              key: "tubes",
              requested: "",
              taken: "",
            },
            {
              label: "Lavender Top/EDTA",
              key: "lavender_top_edta",
              requested: "",
              taken: "",
            },
            {
              label: "Light Blue Tubes",
              key: "light_blue_tubes",
              requested: "",
              taken: "",
            },
            {
              label: "SST/Tiger Top",
              key: "sst_tiger_top",
              requested: "",
              taken: "",
            },
            {
              label: "Lithium Heparin/Green Top",
              key: "lithium_Heparin_green_top",
              requested: "",
              taken: "",
            },
            {
              label: "Transfer Tubes",
              key: "transfer_tubes",
              requested: "",
              taken: "",
            },
            {
              label: "Urinalysis Tubes",
              key: "urinalysis_tubes",
              requested: "",
              taken: "",
            },
          ],
        },
        {
          category_name: "Shipping Supplies",
          fields: [
            {
              label: "Straight Needles 21g",
              key: "straight_needles_21g",
              requested: "",
              taken: "",
            },
            {
              label: "Straight Needles 23g",
              key: "straight_needles_23g",
              requested: "",
              taken: "",
            },
          ],
        },
        {
          category_name: "Collection Supplies",
          fields: [
            {
              label: "2X2 Gauze",
              key: "2X2_gauze",
              requested: "",
              taken: "",
            },
            {
              label: "Alcohol Prep Pads",
              key: "alcohol_prep_pads",
              requested: "",
              taken: "",
            },
            {
              label: "Bandaids",
              key: "bandaids",
              requested: "",
              taken: "",
            },
            {
              label: "Coban",
              key: "coban",
              requested: "",
              taken: "",
            },
            {
              label: "Tourniquet",
              key: "tourniquet",
              requested: "",
              taken: "",
            },
            {
              label: "Hubs/Needle Holders",
              key: "hubs_needle_holders",
              requested: "",
              taken: "",
            },
          ],
        },
        {
          category_name: "",
          fields: [
            {
              label: "Kangaroo Mailers",
              key: "kangaroo_mailers",
              requested: "",
              taken: "",
            },
            {
              label: "Ice Packs",
              key: "ice_packs",
              requested: "",
              taken: "",
            },
            {
              label: "Fed Ex Bags",
              key: "fed_ex_bags",
              requested: "",
              taken: "",
            },
            {
              label: "Fed Ex Labels",
              key: "fed_ex_labels",
              requested: "",
              taken: "",
            },
          ],
        },
        {
          category_name: "",
          fields: [
            {
              label: "Printer Paper",
              key: "printer_paper",
              requested: "",
              taken: "",
            },
            {
              label: "Label Rolls",
              key: "label_rolls",
              requested: "",
              taken: "",
            },
            {
              label: "Printer Ink",
              key: "printer_ink",
              requested: "",
              taken: "",
            },
            {
              label: "Sharps Containers",
              key: "sharps_containers",
              requested: "",
              taken: "",
            },
            {
              label: "Waste Pickup Boxes",
              key: "waste_pickup_boxes",
              requested: "",
              taken: "",
            },
          ],
        },
        {
          category_name: "",
          fields: [
            {
              label: "FOBT Kits",
              key: "fobt_kits",
              requested: "",
              taken: "",
            },
            {
              label: "H.Pylori Test Kits",
              key: "h_pylori_test_kits",
              requested: "",
              taken: "",
            },
            {
              label: "Tox/UTI/STD Kits",
              key: "tox_uti_std_kits",
              requested: "",
              taken: "",
            },
            {
              label: "Pap Test Kits",
              key: "pap_test_kits",
              requested: "",
              taken: "",
            },
          ],
        },
        {
          category_name: "",
          fields: [
            {
              label: "Other",
              key: "other",
              requested: "",
              taken: "",
            },
            {
              label: "Item",
              key: "item",
              requested: "",
              taken: "",
            },
            {
              label: "Item",
              key: "item",
              requested: "",
              taken: "",
            },
          ],
        },
      ],
      patientInformationForm: {
        first_name: "",
        middle_name: "",
        last_name: "",
        date_of_birth: "",
        email: "",
        phone: "",
        code: "",
      },
      logisticInformation: {
        employee_name: "",
        date_requested: "",
        needles: {
          requested: "",
          taken: "",
        },
        butterfly_needle: {
          requested: "",
          taken: "",
        },
        tubes: {
          requested: "",
          taken: "",
        },
        lavender_top_edta: {
          requested: "",
          taken: "",
        },
        light_blue_tubes: {
          requested: "",
          taken: "",
        },
        sst_tiger_top: {
          requested: "",
          taken: "",
        },
        lithium_heparin_green_top: {
          requested: "",
          taken: "",
        },
        transfer_tubes: {
          requested: "",
          taken: "",
        },
        urinalysis_tubes: {
          requested: "",
          taken: "",
        },
        straight_needles_21g: {
          requested: "",
          taken: "",
        },
        straight_needles_23g: {
          requested: "",
          taken: "",
        },
        two_by_two_gauze: {
          requested: "",
          taken: "",
        },
        alcohol_prep_pads: {
          requested: "",
          taken: "",
        },
        bandaids: {
          requested: "",
          taken: "",
        },
        coban: {
          requested: "",
          taken: "",
        },
        tourniquet: {
          requested: "",
          taken: "",
        },
        hubs_needle_holders: {
          requested: "",
          taken: "",
        },
        kangaroo_mailers: {
          requested: "",
          taken: "",
        },
        ice_packs: {
          requested: "",
          taken: "",
        },
        fed_ex_bags: {
          requested: "",
          taken: "",
        },
        fed_ex_labels: {
          requested: "",
          taken: "",
        },
        printer_papers: {
          requested: "",
          taken: "",
        },
        label_rolls: {
          requested: "",
          taken: "",
        },
        printer_ink: {
          requested: "",
          taken: "",
        },
        sharps_containers: {
          requested: "",
          taken: "",
        },
        waste_pickup_boxes: {
          requested: "",
          taken: "",
        },
        fobt_kits: {
          requested: "",
          taken: "",
        },
        h_pylori_test_kits: {
          requested: "",
          taken: "",
        },
        tox_uti_std_kits: {
          requested: "",
          taken: "",
        },
        pap_test_kits: {
          requested: "",
          taken: "",
        },
        other_1: {
          requested: "",
          taken: "",
        },
        other_2: {
          requested: "",
          taken: "",
        },
        other_3: {
          requested: "",
          taken: "",
        },
      },
      rules: {
        employee_name: [
          {
            required: true,
            message: "Employee name is required",
            trigger: "blur",
          },
        ],
        date_requested: [
          {
            required: true,
            message: "Date is required",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      getAcceptingCookies: false,
      testRequestDatePickerOptions: {
        disabledDate(date) {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          return date < yesterday;
        },
      },
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("patientPortal", ["getPatientInformation", "getPatientInfo"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("logistics", [
      "getAddLogisticStatus",
      "getSingleLogistic",
      "getLogisticUpdateStatus",
    ]),
  },

  methods: {
    upper(e) {
      this.patientInformationForm.first_name = e.toUpperCase();
      this.patientInformationForm.middle_name = e.toUpperCase();
      this.patientInformationForm.last_name = e.toUpperCase();
    },
    convertToLower(value) {
      if (value) {
        this.patientInformationFormData.email = value.toLowerCase();
      }
    },

    setPatientInfo() {
      this.patientInformationForm.first_name = this.getPatientInfo.first_name;
      this.patientInformationForm.middle_name = this.getPatientInfo.middle_name;
      this.patientInformationForm.last_name = this.getPatientInfo.last_name;
      this.patientInformationForm.date_of_birth =
        this.getPatientInfo.date_of_birth;
      this.patientInformationForm.phone = this.getPatientInfo.phone;

      if (this.getPatientInfo && this.getPatientInfo.email) {
        this.patientInformationForm.email = this.getPatientInfo.email;
      }
    },
    cancelOrder() {
      this.$router.push({ name: "SelectingTest" });
    },
    submitForm(formName) {
      try {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addLogistic();
          } else {
            return false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    supplyForm(formName) {
      try {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addSupplyForm();
          } else {
            return false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async addSupplyForm() {
      this.loading = true;
      let params = this.logisticInformation;
      params.status = "pending";
      params.lab_code = "MHC";
      if (this.date_requested) {
        const dateRequested = moment(this.date_requested).format("yyyy-MM-dd");

        params.date_requested = dateRequested;
      }
      await this.$store.dispatch("logistics/addLogistic", params);
      this.loading = false;
      if (this.getAddLogisticStatus) {
        successNotification("New Logistic Created Successfully");
        this.resetForm();
      } else {
        errorNotification("Error while Creating Logistic");
      }
    },
    async addLogistic() {
      this.loading = true;
      let params = this.logisticInformation;
      params.status = "pending";
      params.lab_code = "DLW";
      if (this.date_requested) {
        const dateRequested = moment(this.date_requested).format("yyyy-MM-dd");

        params.date_requested = dateRequested;
      }
      await this.$store.dispatch("logistics/addLogistic", params);
      this.loading = false;
      if (this.getAddLogisticStatus) {
        successNotification("New Logistic Created Successfully");
        this.resetForm();
      } else {
        errorNotification("Error while Creating Logistic");
      }
    },
    resetForm() {
      this.$router.push({ name: "Supply-Request-Success" });
    },
    async orderATest() {
      await this.$store.dispatch(
        "patientPortal/setPatientInfo",
        this.patientInformationForm
      );

      try {
        if (this.patientInformationForm.email) {
          this.patientInformationForm.email =
            this.patientInformationForm.email.toLowerCase();
        }
        this.loading = true;
        await this.$store.dispatch(
          "patientPortal/orderAtest",
          this.patientInformationForm
        );
        if (this.getPatientInformation) {
          successNotification(this.getPatientInformation.message);
          this.$router.push({
            name: "OTPVerification",
          });
        } else if (this.getError) {
          errorNotification(this.getError);
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/responsive.scss";

.selecting-test-form {
  min-height: 100vh;
  background-color: #f9f9f9;
  @include media-breakpoint-down(lg) {
    padding: 0 1.5em !important;
  }
  .test-step {
    display: flex;
    width: 100%;
    min-height: 100vh;
    & > .el-row {
      width: 100%;
      align-items: center;
    }
    .step-heading {
      margin-bottom: 2em;
      h3 {
        font-size: 1.25em;
      }
      p {
        margin: 0;
        color: #616161;
      }
    }
    .step-content {
      margin-bottom: 2em;
    }
    .step-action-block {
      text-align: right;
      margin-top: 1.5em;

      .el-button {
        font-size: 1em;
        font-weight: 600;
        border-radius: 3px;
        &:hover {
          background-color: transparent;
        }
        &.btn-muted {
          color: #7a7a7a;
          border-color: #b3b3b3;
          &:hover {
            background-color: #7a7a7a;
            border-color: #7a7a7a;
            color: #ffffff;
          }
        }
        &.btn-primary {
          background-color: #215fad;
          border-color: #215fad;
          color: #ffffff;
          &:hover {
            background-color: #ffffff;
            color: #215fad;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.selecting-test-form {
  .el-input {
    text-transform: uppercase;
  }
  .step-3 {
    .ordering-form {
      margin: 0 auto;
      .error {
        color: #ff5555;
      }
      .el-form-item {
        display: flex;
        margin-bottom: 22px;
        align-items: center;
      }
      .mandatory-field {
        .el-form-item__label:before {
          content: "*";
          color: red !important;
          font-size: 1.1em;
          line-height: 1;
          padding-left: 2px;
        }
        .phone-number {
          align-items: flex-start;
        }
      }
      .el-date-editor {
        .el-input__inner {
          padding-left: 15px;
        }
        .el-input__prefix {
          left: auto;
          right: 8px;
          .el-input__icon {
            font-size: 20px;
            color: #222222;
          }
        }
      }
      .el-input__inner {
        background: #ffffff;
        color: #000;
        border: 0.922417px solid rgba(156, 156, 156, 0.5);
        font-weight: 500;
        font-size: 13px;
        height: 28px;
        box-sizing: border-box;
        border-radius: 3.56227px;
        margin-top: 3px;
        height: 35px !important;
        transition: 0.3s all ease-in-out;
        -webkit-transition: 0.3s all ease-in-out;

        &:disabled {
          border-top: none !important;
          border-bottom: none !important;
        }

        ::placeholder {
          color: red;
        }
      }
      .el-form-item__label {
        color: #222222;
        font-size: 15px;
        line-height: 1.5;
        margin-bottom: 4px;
      }
      .el-input__suffix {
        right: 30px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#supply-request {
  border: 1px solid #ebeef5;
  color: #303133;
  transition: 0.3s;
  max-width: 1000px;
  margin: 0 auto;
  .logo-navbar {
    background: #273480;
    padding: 5px 30px;
    .logo-dlw {
      padding: 5px 0;
      img {
        width: 80px;
      }
    }
    .logo-mgh {
      padding: 5px 0;
      img {
        width: 150px;
      }
    }

    h3 {
      color: #fff;
      font-size: 1.2em;
      text-align: right;
    }
  }
  .form-title {
    margin-bottom: 30px;
    text-align: center;
    color: #061845;
    font-weight: 600;
    font-size: 1.2em;
  }
  #content-body {
    padding: 20px;
    margin-bottom: 75px;
  }
  .divider {
    height: 40px;
    position: relative;
  }
  .each-supply-step {
    ul {
      border: 1px solid #ebeef5;
      li {
        border-bottom: 1px solid #ebeef5;
        display: grid;
        grid-template-columns: 300px 1fr 1fr;
        &.heading {
          background: #273480;
          color: #fff;
          font-weight: 600;
          p {
            margin: 0;
            padding: 5px 15px;
            &:not(:last-child) {
              border-right: 1px solid rgba(255, 255, 255, 0.5);
            }
          }
        }
        .name,
        .form-item {
          padding: 8px 15px;
          border-right: 1px solid #ebeef5;
          .el-input__inner {
            &:focus {
              border: none !important;
              border-radius: 0;
            }
          }
          .el-form-item {
            margin-bottom: 0;
            .error {
              font-size: 12px;
              padding-left: 5px;
            }
          }
        }
        .name {
          background: #f5f5f5;
          display: flex;
          align-items: center;
          text-align: left;
          border-right: 1px solid #ebeef5;
          h4 {
            color: #215fad;
            font-weight: 500;
            font-size: 15px;
          }
        }
      }
    }
  }

  .step-action-block {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #f2f2f2;
    border-top: 1px solid rgba(156, 156, 156, 0.2);

    padding: 10px 0;
    ul {
      max-width: 1000px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    button {
      box-sizing: border-box;
      min-height: 30px;
      padding: 0px 20px;
      line-height: 4px;
      border-radius: 7.39894px;
      font-weight: 500;
      text-transform: uppercase;
      font-size: 14px;
      background: #ffffff;
      color: #273480;
      border: 0.719521px solid #dedbdb;
      border-radius: 5px;
      &.btn-primary {
        background: #273480;
        color: #ffffff;
        margin: 0 0 0 10px;
        border: none;
        &:hover,
        &:active {
          background: #273480;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.signature-step {
  label {
    color: #222222;
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 4px;
  }
  .el-upload-dragger {
    height: 100px;
    line-height: 100px;
    .el-icon-upload {
      margin-top: 20px;
    }
  }
}
</style>
